import { Component } from 'react';
import { Button } from 'antd';

import { i18n } from '../../i18n';

class ErrorBoundary extends Component {
  state = {
    hasError: false,
    errorMessage: '',
  };

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error.message };
  }

  render() {
    const {
      state: { hasError, errorMessage },
      props: { children },
    } = this;

    if (hasError) {
      return (
        <div className='wm-center-page wm-center-page--full'>
          <div className='wm-empty wm-empty--error' role='alert'>
            <div className='wm-empty__icon'>
              <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.75' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
                <path d='m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3' />
                <path d='M12 9v4' />
                <path d='M12 17h.01' />
              </svg>
            </div>
            <div className='wm-empty__title'>{i18n.t('errorBoundary.title')}</div>
            <div className='wm-empty__text'>{i18n.t('errorBoundary.text')}</div>
            {errorMessage && (
              <code className='wm-muted' style={{ fontSize: 12, marginTop: 8 }}>
                {errorMessage}
              </code>
            )}
            <div className='wm-empty__action'>
              <Button type='primary' onClick={() => window.location.reload()}>
                {i18n.t('errorBoundary.reload')}
              </Button>
            </div>
          </div>
        </div>
      );
    }
    return children;
  }
}

export default ErrorBoundary;
